import { useQuery } from '@tanstack/react-query';
import { strapiListUserTypes } from '../../api/strapiUserTypes';
import { queryKeys } from '../queryKeys';

export function useUserTypesQuery(jwt: string | null) {
  return useQuery({
    queryKey: queryKeys.userTypes(jwt),
    queryFn: () => strapiListUserTypes(jwt!),
    enabled: Boolean(jwt),
    staleTime: 60_000,
  });
}
